// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3aIuO","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1oEQF","obliqueLine":"membershipbadge_obliqueLine__2rbrr"};